import { createHttpAction } from '@minerva-analytics/pantheon';

import { LUCINA_URL } from '../../../constants';

const {
  getNewsletterStart,
  getNewsletterSuccess,
  getNewsletterFailure,  
  getNewsletterWithOptions,
} = createHttpAction('GET_NEWSLETTER');

export const getNewsletter = (site, configName, configTag) => {
	
  return getNewsletterWithOptions({
    method: 'get',
    url: `${LUCINA_URL}/newsletteroutputs/get_latest_newsletter/?site=${site}&name=${configName}&tag=${configTag}`,
  });

};

export default {
  getNewsletter,
  getNewsletterStart,
  getNewsletterSuccess,
  getNewsletterFailure,  
  getNewsletterWithOptions,
};